<template lang="html">
  <div class="finca-view la-tierra">
    <section
      class="banner-intro animation full-view-intro column-center brown"
      data="la-tierra"
    > 
 <div class="contenedor-titulos">
        <h1 class="title -intro">{{ $t("vistas.la_tierra") }}</h1>

        <h2 class="subtitle-intro">{{ $t("vistas.la_finca") }}</h2>
      </div>

      <video
        controls="false"
        loop="true"
        muted="true"
        id="video-tierra"
        autoplay="true"
        playsinline
      >
        <source src="/static/video/video-finca-full.mp4" type="video/mp4" />
      </video>
      <span class="hideVideoBtn" v-on:click="quitarVideo" :hide="hideVideo">✕</span>
      <video
        controls="false"
        loop="true"
        muted="true"
        id="video-puerta"
        autoplay="true"
        playsinline
        :hide="hideVideo"
      >
      
  <source src="/static/video/video-puertas.mp4" type="video/mp4" />
      </video>
     
    </section>

    <section class="new-texto-imagen row-center ais animation">
      <div class="textos column-center">
        <h2 class="title">
          {{ $t("la_tierra.la_tierra.cuadro_uno.titulo") }}
        </h2>
        <p>{{ $t("la_tierra.la_tierra.cuadro_uno.texto") }}</p>
      </div>
      <div class="contenedor-imagen">
        <img src="/static/img/la-tierra/background-el-entorno.jpg" alt="" />
      </div>
    </section>

    <section class="new-texto-imagen -inverse row-center ais animation">
      <div class="contenedor-imagen">
        <img src="/static/img/la-tierra/background-la-tierra.jpg" alt="" />
      </div>

      <div class="textos column-center">
        <h2 class="title">{{ $t("la_tierra.la_tierra.cuadro_dos.titulo") }}</h2>
        <p
          class="with-line"
          v-html="$t('la_tierra.la_tierra.cuadro_dos.texto_uno')"
        ></p>
        <p
          class="with-line"
          v-html="$t('la_tierra.la_tierra.cuadro_dos.texto_dos')"
        ></p>
        <p
          class="with-line"
          v-html="$t('la_tierra.la_tierra.cuadro_dos.texto_tres')"
        ></p>
        <p
          class="with-line"
          v-html="$t('la_tierra.la_tierra.cuadro_dos.texto_cuatro')"
        ></p>
        <p
          class="with-line"
          v-html="$t('la_tierra.la_tierra.cuadro_dos.texto_cinco')"
        ></p>
      </div>
    </section>

    <section class="imagen-full-texto row-start animation" data="los-frutos">
      <video
        controls="false"
        loop="true"
        muted="true"
        id="video-frutos"
        autoplay="true"
        playsinline
      >
        <source src="/static/video/video-frutos.mp4" type="video/mp4" />
      </video>

      <div class="contenedor-texto column-start">
        <h2 class="title">
          {{ $t("la_tierra.la_tierra.frutos.titulo") }}
        </h2>
        <p>
          {{ $t("la_tierra.la_tierra.frutos.cuerpo") }}
        </p>
      </div>
    </section>

    <section class="textos-escalera animation">
      <div class="listado-escalera container row-between aifs">
        <article class="escalera-el" data="vinedos">
          <h2 class="title -black">
            {{ $t("la_tierra.la_tierra.escalera.vinedo.titulo") }}
          </h2>

          <p>{{ $t("la_tierra.la_tierra.escalera.vinedo.cuerpo") }}</p>
        </article>

        <article class="escalera-el" data="azafranal">
          <h2 class="title -black">
            {{ $t("la_tierra.la_tierra.escalera.azafranal.titulo") }}
          </h2>
          <p>
            {{ $t("la_tierra.la_tierra.escalera.azafranal.cuerpo") }}
          </p>
        </article>

        <article class="escalera-el" data="olivos">
          <h2 class="title -black">
            {{ $t("la_tierra.la_tierra.escalera.olivos.titulo") }}
          </h2>
          <p>{{ $t("la_tierra.la_tierra.escalera.olivos.cuerpo") }}</p>
        </article>
        <div class="certificados">
          <div>
            <img src="/static/img/IFS-logo.png" alt="" />
            <span class="link-certificados"  v-html="$t('Certificados')"></span
            >
          </div>
        </div>
      </div>
    </section>

    <otros-lugares></otros-lugares>

    <donde-estamos></donde-estamos>

    <banner-productos></banner-productos>
  </div>
</template>

<script lang="js">


import otrosLugares from '@/components/parts/otros-lugares';

import dondeEstamos from '@/components/parts/donde-estamos';

import bannerProductos from '@/components/parts/productos-banner';


export default  {
  name: 'la-tierra',
  data(){
    return {
      hideVideo : false
    }
  },
  mounted(){
    setTimeout(e => {
      this.hideVideo = true;
    },13000)

  },
  methods: {
     quitarVideo : function(){
        this.hideVideo = true;
     }
  },
  components : {
    'banner-productos' : bannerProductos,
    'otros-lugares' : otrosLugares,
    'donde-estamos' : dondeEstamos,
  }
}
</script>

<style scoped lang="scss">
.imagen-texto {
  padding: 150px 0 100px 0;

  .container {
    max-width: 1500px;
  }
}

#video-frutos {
  position: absolute;
  left: 50%;
  top: 50%;
  min-width: 100%;
  min-height: 100%;
  transform: translate(-50%, -50%);
}
.hideVideoBtn{
    position: fixed;
    z-index: 130;
    top: 25px;
    cursor: pointer;
    border-radius: 50%;
    border: 1px solid white;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    padding: 25px;
    right: 45px;
    &[hide="true"] {
    opacity: 0;
  }
}
#video-puerta {
  position: fixed;
  left: 50%;
  top: 50%;
  min-width: 100vw;
  min-height: 100vh;
  transform: translate(-50%, -50%);
  z-index: 100;
  pointer-events: none;
  transition: 1s;
  &[hide="true"] {
    opacity: 0;
  }
}

.full-view-intro {
  background: url("/static/img/la-tierra/background-intro.jpg") center/cover
    no-repeat;
  height: 100vh;
  overflow: hidden;

  &::before {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.2);
    z-index: 2;
    content: "";
  }

  .contenedor-titulos {
    position: absolute;
    display: inline-block;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 4;
  }

  #video-tierra {
    pointer-events: none;
    position: absolute;
    min-width: 100vw;
    min-height: 100vh;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}

.new-texto-imagen {
  position: relative;
  z-index: 5;
}

.imagen-full-texto[data="los-frutos"] {
  background: url("/static/img/la-tierra/background-los-frutos.jpg")
    center/cover no-repeat;
}

.imagen[data="la-tierra"] {
  background: url("") center/cover no-repeat;
}

.imagen[data="el-entorno"] {
  background: url("") center/cover no-repeat;
}

@media screen and (max-width: 1900px) {
  .imagen-texto {
    .container {
      max-width: 100%;
      padding-right: 35px;
    }
  }
}

@media screen and (max-width: 1800px) {
  .imagen-texto {
    .container {
      max-width: 1500px;
      padding-left: 20px;
    }
  }
}

@media screen and (max-width: 1200px) {
  .imagen-texto {
    padding-top: 300px;
    .textos {
      padding-top: 50px;
    }
  }
}

@media screen and (max-width: 769px) {
  .escalera-el {
    width: 100%;
    margin-top: 40px !important;
    min-height: 0;
    padding-top: 25px;
    background-size: auto 50px;
    background-position: top right;
  }
}

@media screen and (max-width: 700px) {
  .imagen-texto {
    padding-bottom: 50px;
    .textos {
      padding-top: 0;
    }
  }
  .full-view-intro {
    /*  video{
        display: none;
      }*/
  }
}
.certificados {
  margin-bottom: 25px;
}

</style>



// WEBPACK FOOTER //
// src/components/views/la-tierra/la-tierra.vue